import Link from 'components/Link'
import { APP_CONFIG } from 'Config'

const ModalNotification = ({ notification, openMembershipModal, closeConfirmModal }) => {
    if (!notification) {
        return null
    }

    const {
        type,
        subject,
        body,
        buttonText = false,
        buttonLink = '',
        hyperlink
    } = notification

    const { REACT_APP_UPDATE_MEMBERSHIP } = APP_CONFIG

    const handleButtonClick = buttonText === 'Manage Membership' ? openMembershipModal : closeConfirmModal
    const disableManageMembership = buttonText === 'Manage Membership' && !REACT_APP_UPDATE_MEMBERSHIP

    const renderButton = () => {
        if (buttonText && buttonLink) {
            return (
                <Link 
                    className="btn btn-blue btn-regular" 
                    to={buttonLink} 
                    onClick={disableManageMembership ? null : handleButtonClick}
                    disabled={disableManageMembership}
                >
                    {buttonText}
                </Link>
            )
        }
        if (buttonText && !buttonLink) {
            return (
                <button 
                    className="btn btn-blue btn-regular" 
                    onClick={handleButtonClick} 
                    disabled={disableManageMembership}
                >
                    {buttonText}
                </button>
            )
        }
        return (
            <button className="btn btn-blue btn-regular" onClick={closeConfirmModal}>
                Go Back
            </button>
        )
    }

    const renderBody = () => {
        if (typeof body === 'object' && body[0]) {
            return body.map((b, index) => <span key={index}>{b}</span>)
        }
        return body
    }

    const alertType = type === 'error' ? 'danger' : type

    return (
        <>
            <div className={`${type && 'alert'} alert-${alertType} text-left`}>
                <strong>{subject}</strong>
                {' '}
                {renderBody()}
            </div>
            {hyperlink && (
                <>
                    <a href={hyperlink.url} target="_blank" rel="noopener noreferrer">
                        {hyperlink.text}
                    </a>
                    <br />
                    <br />
                </>
            )}
            <span className="action">
                {renderButton()}
            </span>
        </>
    )
}

export { ModalNotification }